//GeneratorFlag:[NoChange]
import FeatureGroup from './feature-group';

export default {FeatureGroup}
export{FeatureGroup}